import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Tengo que ir al gimnasio?',
  a: 'No. El protocolo se basa en nutrición, sueño y suplementación. Si quieres hacer ejercicio, te damos pautas de 15 minutos, pero no es obligatorio para ver resultados hormonales.'
}, {
  q: '¿Es seguro?',
  a: '100%. Todo lo que recomendamos es natural: comida real, suplementos de venta libre y cambios en el estilo de vida. No recomendamos fármacos ni TRT.'
}, {
  q: '¿Funciona si tengo más de 55 años?',
  a: 'Absolutamente. De hecho, los hombres con más edad son los que ven cambios más dramáticos en su energía y libido al corregir sus deficiencias.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Al realizar el pago, recibes un correo electrónico con acceso inmediato a los archivos PDF y videos para verlos en tu celular, tablet o computadora.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-[#0a0e1a] border-t border-[#c9a84c]/10" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <FadeIn data-id="element-28">
          <div className="text-center mb-16" data-id="element-29">
            <h2 className="text-3xl md:text-4xl font-bold text-[#f5f5f5] mb-4" data-id="element-30">
              Preguntas Frecuentes
            </h2>
            <p className="text-[#9ca3af]" data-id="element-31">
              Todo lo que necesitas saber antes de tomar la decisión.
            </p>
          </div>
        </FadeIn>

        <div className="space-y-4" data-id="element-32">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-33">
              <div className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openIndex === index ? 'bg-[#111827] border-[#c9a84c]/50' : 'bg-[#0a0e1a] border-[#c9a84c]/20 hover:border-[#c9a84c]/40'}`} data-id="element-34">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left" data-id="element-35">
                  <span className="font-bold text-lg text-[#f5f5f5] pr-8" data-id="element-36">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-[#c9a84c] shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-37" />
                </button>
                <AnimatePresence data-id="element-38">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-39">
                      <div className="px-6 pb-5 text-[#9ca3af] leading-relaxed" data-id="element-40">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}